<template>
	<div style="text-align: center">
		<van-image :src="smallLogo" style="width: 100vw;"/>
		<van-image :src="notFound" style="width: 60vw;"/>
	</div>
</template>

<script>

	import {Image} from 'vant';

	export default {
		name: 'Page404',
		components: {
			VanImage: Image
		},
		data() {
			return {
				smallLogo: require('@/assets/small-logo.png'),
				notFound: require('@/assets/404.png')
			}
		}
	}
</script>
